<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <h1 class="headline font-weight-light mb-3">
                    PO Pending
                </h1>
            </v-col>
        </v-row>
        <v-tabs
            v-model="tab"
            background-color="blue accent-2"
            color="lime accent-2"
            class="elevation-2"
            dark
            :grow="true"
        >
            <v-tabs-slider></v-tabs-slider>

            <v-tab
                v-for="i in tabs_name.length"
                :key="i"
                :href="`#tab-${i}`"
                @click="change_tab(tabs_name[i - 1])"
            >
                <v-icon class="mr-1" v-if="tabs_name[i - 1] === active_tab"
                    >mdi-checkbox-marked-circle</v-icon
                >
                {{ tabs_name[i - 1] }}
                <v-chip
                    small
                    class="ml-1 primary--text"
                    color="amber"
                    v-if="data_sum.length > 0"
                    >{{ data_sum[i - 1] }}</v-chip
                >
            </v-tab>

            <v-tab-item
                v-for="i in tabs_name.length"
                :key="i"
                :value="'tab-' + i"
            >
                <v-row>
                    <v-col cols="12">
                        <v-progress-linear
                            v-if="chk_data == true"
                            indeterminate
                            color="cyan"
                        ></v-progress-linear>
                        <v-simple-table
                            class="table-inv"
                            v-if="chk_data == false"
                        >
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">
                                            #
                                        </th>
                                        <th class="text-center">
                                            Case ID
                                        </th>
                                        <th class="text-center">
                                            Sub Status
                                        </th>
                                        <th class="text-center">
                                            PO Number
                                        </th>
                                        <th class="text-center">
                                            Part
                                        </th>
                                        <th class="text-center">
                                            RMA
                                        </th>
                                        <th class="text-center">
                                            CE Status
                                        </th>
                                        <th class="text-center">
                                            CT New
                                        </th>
                                        <th class="text-center">
                                            CT Old
                                        </th>
                                        <th class="text-center">
                                            Return
                                        </th>
                                        <th class="text-center" v-if="i == 1">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="data_main.length > 0">
                                    <tr
                                        v-for="(row, index) in data_main"
                                        :key="index"
                                    >
                                        <td>{{ index + 1 }}.</td>
                                        <td class="text-center">
                                            {{ row.case_id }} <br />
                                            <!-- <v-chip
                                                small
                                                v-if="row.show_ismart == 'Y'"
                                                color="red"
                                                class="white--text"
                                            >
                                                iSmart
                                            </v-chip> -->
                                        </td>
                                        <td class="text-center">
                                            <v-chip small>{{
                                                row.onsite_date
                                            }}</v-chip
                                            ><br />
                                            {{ row.sub_status_name }}
                                        </td>
                                        <td class="text-center">
                                            {{ row.ponumber }}
                                            <v-tooltip
                                                color="black"
                                                bottom
                                                lazy
                                            >
                                                <template #activator="{ on }">
                                                    <v-chip
                                                        v-on="on"
                                                        @click="
                                                            doCopy(row.ponumber)
                                                        "
                                                        small
                                                        class="success"
                                                    >
                                                        <v-icon
                                                            small
                                                            color="white"
                                                            >mdi-clipboard-file-outline</v-icon
                                                        >
                                                    </v-chip>
                                                </template>
                                                <span>Copy</span>
                                            </v-tooltip>
                                        </td>
                                        <td>
                                            <b>{{ row.part_name }}</b> <br />
                                            <span class="font-weight-light">{{
                                                row.part_description
                                            }}</span>
                                        </td>

                                        <td class="text-center">
                                            {{ row.rma }}
                                        </td>
                                        <td class="text-center">
                                            {{ row.ce_status }}
                                        </td>
                                        <td class="text-center">
                                            <v-chip
                                                small
                                                v-if="row.ct_new"
                                                class="mb-1"
                                                >{{ row.ct_new }}</v-chip
                                            ><br />
                                            <v-tooltip
                                                color="black"
                                                bottom
                                                lazy
                                            >
                                                <template
                                                    #activator="{ on }"
                                                    v-if="row.ct_new"
                                                >
                                                    <v-chip
                                                        v-on="on"
                                                        v-if="
                                                            row.ct_new != '' &&
                                                                row.ct_new !==
                                                                    null
                                                        "
                                                        @click="
                                                            doCopy(row.ct_new)
                                                        "
                                                        small
                                                        class="success"
                                                    >
                                                        <v-icon
                                                            small
                                                            color="white"
                                                            >mdi-clipboard-file-outline</v-icon
                                                        >
                                                    </v-chip>
                                                </template>
                                                <span>Copy</span>
                                            </v-tooltip>
                                        </td>
                                        <td class="text-center">
                                            <v-chip
                                                small
                                                v-if="row.ct_old"
                                                class="mb-1"
                                                >{{ row.ct_old }}</v-chip
                                            ><br />
                                            <v-tooltip
                                                color="black"
                                                bottom
                                                lazy
                                            >
                                                <template
                                                    #activator="{ on }"
                                                    v-if="row.ct_old"
                                                >
                                                    <v-chip
                                                        v-on="on"
                                                        v-if="
                                                            row.ct_old != '' &&
                                                                row.ct_old !==
                                                                    null
                                                        "
                                                        @click="
                                                            doCopy(row.ct_old)
                                                        "
                                                        small
                                                        class="success"
                                                    >
                                                        <v-icon
                                                            small
                                                            color="white"
                                                            >mdi-clipboard-file-outline</v-icon
                                                        >
                                                    </v-chip>
                                                </template>
                                                <span>Copy</span>
                                            </v-tooltip>
                                        </td>
                                        <td class="text-center">
                                            <v-chip small>{{
                                                row.ce_return_date_x
                                            }}</v-chip>
                                            <br />
                                            <b>{{ row.return_no }}</b>
                                        </td>
                                        <td class="text-center" v-if="i == 1">
                                            <v-btn
                                                small
                                                rounded
                                                color="amber"
                                                @click="
                                                    func_close(
                                                        row.part_issue_id
                                                    )
                                                "
                                                >Close</v-btn
                                            >
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td
                                            class="text-center"
                                            :colspan="i == 1 ? 8 : 7"
                                        >
                                            no results found
                                        </td>
                                        <br />
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs>
        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    mounted() {
        this.get_data()
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            this.chk_data = true
            let send = {
                status:
                    this.active_tab == "Pending" ? "pending" : "cdaxnotclosed",
            }
            await axios
                .post(url + "po-pending/view", send, this.tk)
                .then((response) => {
                    console.log(response)
                    this.chk_data = false
                    this.data_main = response.data.data
                    this.data_sum = response.data.sum
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        change_tab(st) {
            this.active_tab = st
            this.data_main = []
            this.get_data()
        },
        func_close(id) {
            this.$swal({
                title: "Confirm close this po ?",
                text: "",
                icon: "warning",
                buttons: true,
            }).then((closed) => {
                if (closed) {
                    let send = {
                        part_issue_id: id,
                    }
                    axios
                        .post(url + "po-pending/save", send, this.tk)
                        .then((response) => {
                            // console.log(response)
                            this.$swal({
                                title: "บันทึกข้อมูลเรียบร้อย",
                                icon: "success",
                                timer: 2000,
                            })
                            this.get_data()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        doCopy(text) {
            navigator.clipboard.writeText(text)
        },
    },
    data() {
        return {
            tk: null,
            data_sum: {},
            data_main: [],
            tab: false,
            active_tab: "Pending",
            tabs_name: ["Pending", "CDAX Not Closed"],
            text: "Success, Your work has been saved",
            chk_data: false,
        }
    },
}
</script>
